exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vdpCell.selected .vdpCellContent{background-color:var(--main-color)}.vdpArrowNext:after{border-left-color:var(--main-color)}.vdpArrowPrev:after{border-right-color:var(--main-color)}.vdpComponent{color:var(--main-color-darker-alpha8)}.vdpCell.selectable{font-weight:700}.vdpHeader{background-color:#fff}.vdpHeadCellContent{color:var(--main-color)}.vdpPeriodControl button{color:var(--main-color);font-size:1rem;font-weight:700}.horarios-grid{display:grid;grid-template-columns:1fr 1fr;column-gap:1rem;padding-top:1rem;row-gap:1rem}#modal-confirmacao.modal-footer{border:0}@media screen and (max-width:370px){.horarios-grid{grid-template-columns:100%}}@media only screen and (min-width:1024px){#modal-schedules .modal-dialog{max-width:800px}.horarios-grid{grid-template-columns:1fr 1fr 1fr 1fr}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9f3bef04","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Calendario.vue
// module id = 301
// module chunks = 0